import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";

import alertSlice from "./Alert";
import chatSlice from "./Chat";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

interface PersistConfig {
  key: string;
  storage: any;
  blacklist?: Array<string>;
  whitelist?: Array<string>;
}

const reducer = combineReducers({
  chat: chatSlice.reducer,
  alert: alertSlice.reducer,
});

const persistConfig: PersistConfig = {
  key: "centro-root",
  storage,
  blacklist: [],
};

export const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        // Ignore these field paths in all actions
        /* ignoredActionPaths: ["meta.arg", "payload.timestamp"],
         // Ignore these paths in the state */
        ignoredActions: ["persist/PERSIST"],
        ignoredActionPaths: ["payload.onDismiss", "payload.onConfirm"],
        ignoredPaths: ["alert.onDismiss", "alert.onConfirm"],
      },
    }),
});

export type RootState = ReturnType<typeof reducer>;

const persistor = persistStore(store);

const exportStore = { store, persistor };

export default exportStore;
